import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  private timerInterval: any;

  constructor() { }

  startTimer(
    initialTime: number,
    onTick: (timeLeft: number) => void,
    onComplete?: () => void
  ): void {
    if (initialTime <= 0) return;

    let timeLeft = initialTime;

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      if (timeLeft > 0) {
        timeLeft--;
        onTick(timeLeft);
      } else {
        clearInterval(this.timerInterval);
        if (onComplete) {
          onComplete();
        }
      }
    }, 1000);
  }

  stopTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}
